export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-council-api.tracwater.online',
  portalId: '699d0df98cefcf0e9ea22253',
  selectedNode: ''
};
